import { FC } from 'react'

import { Stack, Typography } from '@mui/material'

import { GameIcon } from '../../../../../features/game'
import { InternalGameDocument } from '../../../games/types/InternalGame'

type ReviewGameHeaderProps = {
  game: InternalGameDocument
  detail?: string
}

export const ReviewGameHeader: FC<ReviewGameHeaderProps> = ({ game, detail }) => (
  <Stack direction="row" spacing={2} alignItems="center">
    <GameIcon src={game.icons?.length ? game.icons : game.icon ?? undefined} gameName={game.name ?? ''} size="small" />
    <Stack>
      <Typography variant="h6">{game.name}</Typography>
      {game.artist && (
        <Typography variant="body2" color="text.secondary">
          {game.artist}
        </Typography>
      )}
      {detail && <Typography variant="body2">{detail}</Typography>}
    </Stack>
  </Stack>
)
